<template :id="message._id">
    <div>
        <div v-if="showDay" class="position-re bg-gray-4 my-2 w-100 show__day">
            <span class="bg-gray-main position-ab px-1 border-radius-5-px cursor-default show__day-format gray-1 rounded-full px-xs py-3xs">{{
                convertDateFormat(message.createdAt)
            }}</span>
        </div>
        <div v-if="showUnread" class="d-flex justify-content-center w-100 mt-10px mb-10px">
            <span class="border-radius-10-px cursor-default text-center unread__message-text bg-lightgreen py-10px"
                >{{ showUnread }} {{ $t("Comments.unread_message") }}</span
            >
        </div>
        <div
            class="message d-flex align-items-center"
            :style="{ marginBottom: showMessageTime ? '15px' : message.reactions?.length ? '15px' : '4px' }"
            :class="{ 'right-message': message.sent }"
        >
            <div class="d-flex" :style="{ paddingLeft: !message.sent && !showUser ? '40px' : '' }">
                <UserProfile
                    v-if="!message.sent && showUser"
                    :showDot="false"
                    class="cursor-pointer profile-image message__profile-image mr-10px"
                    title="Xem hồ sơ"
                    @click.stop="openUserProfile(message.userId)"
                    :data="{
                        id: message.userId,
                        title: getUser(message.userId).Employee_Name,
                        image: getUser(message.userId).Employee_profileImageURL,
                    }"
                    width="30px"
                    :thumbnail="'120x120'"
                />
                <div>
                    <div
                        v-if="showSenderName || (!message.sent && showUser && isGroupChat)"
                        class="cursor-default mb-5px"
                        :class="message.sent ? 'text-right' : 'text-left'"
                    >
                        <span class="font-size-12 font-weight-500 mr-5px color63 show__user" style="opacity: 0.8">
                            {{ getUser(message.userId).Employee_Name }}
                        </span>
                    </div>
                    <div class="d-flex position-re" :class="{ 'justify-content-end': message.sent, 'flex-column-reverse': !message.sent, 'flex-column': message.sent  }">
                        <span
                            v-if="
                                showOptions && !message.isDeleted &&
                                message.sent &&
                                new Date(message.createdAt)?.getTime() !== new Date(message.updatedAt)?.getTime()
                            "
                            class="edited-message-text"
                            >{{ $t('Comments.edited', 'Edited') }}</span
                        >
                        <div
                            :id="message._id"
                            class="p-10px message_id-sent position-re"
                            :class="{
                                'bg-white': !message.sent && message.type !== 'sticker' && message.type !== 'image',
                                'bg-light-blue': message.sent && message.type !== 'sticker' && message.type !== 'image',
                            }"
                            :style="`${message.type !== 'text' || message.type !== 'link' ? 'width: auto;' : ''}`"
                        >
                            <template v-if="message.isDeleted">
                                <pre
                                    class="blue font-italic"
                                    v-html="
                                        $t('Comments.This_message_is_deleted')
                                    "
                                />
                            </template>
                            <template v-else>
                                <!-- IMAGE -->
                                <template v-if="message.type === 'image'">
                                    <div class="d-flex flex-column" @click.prevent="previewImageFun()">
                                        <ImageIcon
                                            v-if="message?.mediaURL?.includes('http')"
                                            :src="message.mediaURL"
                                            :alt="message.mediaOriginalName"
                                            :extension="message.mediaOriginalName?.split('.').pop()"
                                            class="comment__image"
                                        />
                                        <WasabiImageComp
                                            v-else
                                            :data="{
                                                url: message.mediaURL,
                                                title: message.mediaOriginalName,
                                                filename: message.mediaOriginalNamem,
                                                extension: message.mediaOriginalName?.split('.').pop(),
                                            }"
                                            @downloadUrl="handleDownloadUrl"
                                            class="comment__image"
                                        />
                                    </div>
                                </template>

                                <!-- STICKER -->
                                <template v-else-if="message.type === 'sticker'">
                                    <div class="d-flex flex-column">
                                        <img v-if="message.mediaURL?.includes('http')" class="comment__sticker" :src="message.mediaURL" />
                                        <WasabiImageComp
                                            v-else
                                            :data="{
                                                url: message.mediaURL,
                                                title: message.mediaOriginalName || message.mediaName,
                                                filename: message.mediaOriginalName || message.mediaName,
                                                extension: (message.mediaOriginalName || message.mediaName)?.split('.').pop(),
                                            }"
                                            @downloadUrl="handleDownloadUrl"
                                            class="comment__sticker"
                                        />
                                    </div>
                                </template>
                                <template v-else-if="message.type === 'like'">
                                    <img :src="likeIcon" class="like-bubble" />
                                </template>

                                <template v-else-if="message.type === 'audio'">
                                    <div class="d-flex flex-column">
                                        <WasabiAudioComp
                                            :id="`audio_${message._id}`"
                                            @downloadUrl="handleDownloadUrl"
                                            :data="message.mediaURL"
                                            @play="pauseOthers(message.type, `audio_${message._id}`)"
                                        />
                                    </div>
                                </template>

                                <template v-else-if="message.type === 'video'">
                                    <div class="d-flex flex-column" @click.prevent="previewImageFun()">
                                        <WasabiVideoComp
                                            @downloadUrl="handleDownloadUrl"
                                            :id="`video_${message._id}`"
                                            :data="message.mediaURL"
                                            class="comment-media video_controls"
                                            @play="pauseOthers(message.type, `video_${message._id}`)"
                                        />
                                    </div>
                                </template>
                                <template v-else-if="message.type !== 'text' && message.type !== 'link'">
                                    <div class="d-flex gap" @click.prevent="previewImageFun()">
                                        <ImageIcon
                                            v-if="message?.mediaURL?.includes('http')"
                                            :src="message.mediaURL"
                                            :extension="getFileCardExtension(message)"
                                            :alt="message.mediaName"
                                            class="comment-media comment__file"
                                        />
                                        <ImageIcon
                                            v-else-if="isPendingMessage(message)"
                                            :src="message.mediaURL || message.mediaName || message.mediaOriginalName"
                                            :extension="getFileCardExtension(message)"
                                            :alt="message.mediaName"
                                            class="comment-media comment__file"
                                        />
                                        <WasabiImageComp
                                            v-else
                                            :data="{
                                                url: message.mediaURL,
                                                title: message.mediaOriginalName,
                                                filename: message.mediaOriginalName,
                                                extension: getFileCardExtension(message),
                                            }"
                                            class="comment-media comment__file"
                                            @downloadUrl="
                                                (eve) => {
                                                    downloadurl(eve);
                                                }
                                            "
                                        />
                                        <div class="file-info">
                                            <div class="file-name text-ellipsis">
                                                {{ message.mediaOriginalName || message.mediaName }}
                                            </div>
                                            <div class="file-size font-size-12 gray">
                                                {{ formatFileSize(message.mediaSize) }}
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <template v-if="message.hasReply">
                                        <div
                                            @click="$emit('highlight', getReplyHighlightTarget(message))"
                                            class="d-flex align-items-center cursor-pointer p-10px mb-5px message_replay"
                                            :class="{ 'bg-gray-5': !message.sent, 'bg-dark-blue': message.sent }"
                                        >
                                            <img v-if="getReplyIcon(message)" :src="getReplyIcon(message)" class="reply-file-icon mr-10px" width="25" height="25" />
                                            <div class="d-flex flex-column emp__profile-wrapper">
                                                <strong class="reply-username text-nowrap mr-5px"
                                                    >{{ getUser(message.reply_userId).Employee_Name }}
                                                </strong>
                                                <pre
                                                    class="reply-content text-ellipsis text-nowrap white__space-nowrap"
                                                    :class="{
                                                        'text-muted':
                                                            Boolean(message?.reply_id) && Boolean(messageMap?.[message.reply_id]?.isDeleted),
                                                    }"
                                                    :title="getReplyPreviewText(message)"
                                                    v-html="getReplyPreviewText(message)"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                    <a
                                        v-if="taskShareCard"
                                        :href="taskShareCard.url"
                                        class="task-share-card"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <span class="task-share-card__icon" aria-hidden="true">✓</span>
                                        <span class="task-share-card__content">
                                            <span class="task-share-card__eyebrow">Công việc</span>
                                            <strong class="task-share-card__key">{{ taskShareCard.taskKey }}</strong>
                                            <span class="task-share-card__name">{{ taskShareCard.taskName }}</span>
                                            <span class="task-share-card__action">Mở công việc <span aria-hidden="true">→</span></span>
                                        </span>
                                    </a>
                                    <template v-else>
                                        <pre
                                            :class="{ 'para-overflow': message.overflow && !showMore }"
                                            v-html="
                                                message.type === 'link' ? checkLink(changeText(message.message), true) : changeText(message.message)
                                            "
                                        />
                                        <div
                                            v-if="message.overflow"
                                            class="text-center cursor-pointer border-top mt-10px pt-5px text-center"
                                            @click="showMore = !showMore"
                                        >
                                            <span>{{ $t("Permissions.Read") }} {{ showMore ? $t("Comments.less") : $t("Comments.more") }}</span>
                                        </div>
                                    </template>
                                </template>
                                <div
                                    v-if="message.sendStatus === 'failed'"
                                    class="message-send-status"
                                    :class="{ 'red': message.sendStatus === 'failed' }"
                                >
                                    Failed to send
                                </div>
                                <div
                                    v-else-if="isPendingMessage(message) && isPendingMediaMessage(message)"
                                    class="message-send-status message-send-status--loading"
                                >
                                    <span class="message-send-spinner"></span>
                                    Uploading...
                                </div>
                                <div class="font-size-12 font-weight-300 gray text-lowercase show" v-if="showMessageTime">
                                    {{ getDateType(new Date(message.createdAt).getTime()) }}
                                </div>
                            </template>
                            <div v-if="!message.isDeleted" :class="{ 'drop-right': message.sent, 'drop-left': !message.sent }" class="d-flex action_message position-ab">
                                <div v-if="showOptions"
                                    class="reaction-wrapper actions__dropdown"
                                    @mouseenter="openReaction(message._id)"
                                    @mouseleave="closeReaction(message._id)"
                                >
                                    <img
                                        :ref="`message_option_${message._id}`"
                                        :src="reactionChat"
                                        alt="reaction"
                                        class="cursor-pointer reaction-btn"
                                    />
                                    <div v-if="reactionPopup === message._id" class="reaction-popup">
                                        <span
                                            v-for="item in reactionList"
                                            :key="item.value"
                                            class="reaction-emoji"
                                            @click.stop="selectReaction(message, item)"
                                        >
                                            <img class="reaction-img" :src="item.displaySrc" loading="eager" />
                                        </span>

                                        <img
                                            v-if="message.reactions?.length && hasOwnReaction(message)"
                                            class="reaction-remove-icon"
                                            :src="removeReactionIcon"
                                            @click.stop="removeMyReaction(message)"
                                            title="Remove reaction"
                                        />
                                    </div>
                                </div>
                                <div v-if="showOptions" class="actions__dropdown" @click.stop="$emit('reply', message)">
                                    <img
                                        :ref="`message_option_${message._id}`"
                                        :src="replyChatGrey"
                                        alt="replyChat"
                                        class="cursor-pointer reply-icon"
                                    />
                                </div>
                                <DropDown v-if="showOptions" class="align-self-start" :bodyClass="{ 'comments__message--dropdown': true }">
                                    <template #button>
                                        <div class="actions__dropdown">
                                            <img
                                                :ref="`message_option_${message._id}`"
                                                :src="verticalDots"
                                                alt="verticalDots"
                                                class="cursor-pointer verticalDots"
                                                :bodyClassHeader="{ aaa: true }"
                                            />
                                        </div>
                                    </template>
                                    <template #options>
                                        <template v-if="!message.isDeleted">
                                            <DropDownOption
                                                v-if="
                                                    message.sent &&
                                                    (message.type === 'text' || message.type === 'link') &&
                                                    new Date(message.createdAt).setSeconds(0, 0) > new Date().setSeconds(0, 0) - 360000
                                                "
                                                @click="
                                                    $emit('edit', JSON.parse(JSON.stringify(message))), $refs[`message_option_${message._id}`].click()
                                                "
                                            >
                                                {{ $t("Comments.edit") }}
                                            </DropDownOption>
                                            <DropDownOption
                                                v-if="!mainChat && (message.type === 'text' || message.type === 'link')"
                                                @click="$emit('createTask', message), $refs[`message_option_${message._id}`].click()"
                                            >
                                                {{ $t("Comments.create_task") }}
                                            </DropDownOption>
                                            <DropDownOption
                                                v-if="!mainChat && (message.type === 'text' || message.type === 'link')"
                                                @click="$emit('addCheckList', message), $refs[`message_option_${message._id}`].click()"
                                            >
                                                {{ $t("Comments.add_to_checklist") }}
                                            </DropDownOption>
                                            <DropDownOption
                                                v-if="message.type === 'text' || message.type === 'link'"
                                                @click="$emit('copy', message), $refs[`message_option_${message._id}`].click()"
                                            >
                                                {{ $t("Comments.copy_message") }}
                                            </DropDownOption>
                                            <DropDownOption
                                                v-if="!isChannel"
                                                @click="$emit('share', message), $refs[`message_option_${message._id}`].click()"
                                            >
                                                {{ $t("ChatDetail.share", "Share") }}
                                            </DropDownOption>
                                            <DropDownOption
                                                v-if="message.sent"
                                                @click="$emit('delete', message), $refs[`message_option_${message._id}`].click()"
                                            >
                                                {{ $t("Projects.delete") }}
                                            </DropDownOption>
                                            <!-- <DropDownOption
                                                v-if="messageAllowed"
                                                @click="$emit('reply', message), $refs[`message_option_${message._id}`].click()"
                                            >
                                                {{ $t("Comments.reply") }}
                                            </DropDownOption> -->
                                            <DropDownOption
                                                v-if="mainChat && canPin"
                                                @click="$emit('pin', message), $refs[`message_option_${message._id}`].click()"
                                            >
                                                {{ !message?.pinnedMessage ? $t("Projects.pin") : $t("Projects.unpin") }} {{ $t("Comments.message") }}
                                            </DropDownOption>
                                        </template>
                                        <DropDownOption
                                            id="mark_as_unread"
                                            @click="showUnread ? '' : $emit('markUnread', message), $refs[`message_option_${message._id}`].click()"
                                        >
                                            {{ $t("Comments.mark_unread") }}
                                        </DropDownOption>
                                    </template>
                                </DropDown>
                            </div>
                        </div>
                        <span
                            v-if="
                                showOptions && !message.isDeleted && !message.sent && new Date(message.createdAt).getTime() !== new Date(message.updatedAt).getTime()
                            "
                            class="edited-message-text"
                            >{{ $t('Comments.edited', 'Edited') }}</span
                        >
                        <div
                            v-if="showOptions && message.reactions?.length && !message.isDeleted"
                            class="reaction-wrap position-ab d-flex align-items-center"
                            :style="{
                                bottom:
                                    message.type === 'image'
                                        ? (showMessageTime ? '20px' : '0px')
                                        : '-12px'
                            }"
                            :class="{ 'reaction-right': message.sent, 'reaction-left': !message.sent }"
                        >
                            <!-- Reaction Pill -->
                            <div class="reaction-pill d-flex align-items-center border-radius-10-px p-xs cursor-pointer" @click="$emit('reaction', {message: message, action: 'open'})">
                                <div class="reaction-icons-row d-flex">
                                    <img v-for="(item, index) in topReactionEmojis" :key="index" :src="item.icon" class="reaction-img-small" :class="{'overlap-icon': index > 0}" alt="reaction" />
                                </div>
                                <span class="reaction-count-text ml-5px font-size-12">{{ totalReactionCount }}</span>
                            </div>

                            <!-- Own Reaction Bubble -->
                            <div v-if="ownLatestReaction" class="own-reaction-bubble d-flex align-items-center justify-content-center border-radius-50-per ml-5px cursor-pointer" @click="$emit('reaction', {message: message, action: 'open'})">
                                <img :src="ownLatestReaction.icon" class="reaction-img-small" alt="own-reaction" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
// PACKAGES
import { i18n } from "@/locales/main";

import { defineComponent, defineProps, inject, onMounted, ref } from "vue";
import { useConvertDate, useCustomComposable, useGetterFunctions } from "@/composable";

// COMPONENTS
import WasabiImageComp from "@/components/atom/WasabiIamgeCompp/WasabiIamgeCompp.vue";
import WasabiAudioComp from "@/components/atom/wasabiComps/wasabAudio.vue";
import WasabiVideoComp from "@/components/atom/wasabiComps/wasabVideo.vue";
import DropDown from "@/components/molecules/DropDown/DropDown.vue";
import DropDownOption from "@/components/molecules/DropDownOption/DropDownOption.vue";
import ImageIcon from "@/components/atom/ImageIcon/ImageIcon.vue";
import UserProfile from "@/components/atom/UserProfile/UserProfile.vue";
import { useProjects } from "@/composable/projects";
import removeReactionIcon from "@/assets/images/reactions/close.svg";
import { storageHelper } from "@/composable/commonFunction";
import { useMessageReactions } from "@/composable/useMessageReactions";
import { download } from "@/utils/StorageOprations/download";
const { parseTaskShareMessage } = require("@/utils/taskShareMessage.cjs");

import { computed } from "vue";
import { useStore } from "vuex";
const { getStorageImage } = storageHelper();

const { getDateType } = useProjects();

// UTILS
const { changeText, checkLink } = useCustomComposable();
const { convertDateFormat } = useConvertDate();
const { getUser } = useGetterFunctions();

const getReplyIcon = (msg) => {
    const originalMsg = props.messageMap?.[msg.reply_id];
    const type = msg.reply_type || originalMsg?.type;
    if (!type || ['text', 'link', 'sticker', 'image'].includes(type)) return null;
    
    const fileName = msg.reply_mediaOriginalName || msg.reply_mediaName || originalMsg?.mediaOriginalName || originalMsg?.mediaName || "";
    let ext = fileName.split('.').pop()?.toLowerCase();
    if (!ext || ext === fileName.toLowerCase()) {
        ext = type;
    }
    
    switch (ext) {
        case 'pdf': return require("@/assets/images/pdf.png");
        case 'xlsx':
        case 'xls':
        case 'excel': return require("@/assets/images/xls.png");
        case 'docx':
        case 'doc':
        case 'word': return require("@/assets/images/doc.png");
        case 'pptx':
        case 'ppt': return require("@/assets/images/pdf.png");
        case 'zip':
        case 'rar': return require("@/assets/images/zip.png");
        case 'mp4':
        case 'mov': return require("@/assets/images/mp4.png");
        case 'mp3':
        case 'wav': return require("@/assets/images/mp3.png");
        case 'txt': return require("@/assets/images/txt.png");
        default: return require("@/assets/images/svg/file_gray.svg");
    }
};

const getReplyPreviewText = (msg) => {
    if (Boolean(msg?.reply_id) && Boolean(props.messageMap?.[msg.reply_id]?.isDeleted)) {
        return i18n.global.t('general.message_deleted', 'This message has been deleted');
    }
    const originalMsg = props.messageMap?.[msg.reply_id];
    const type = msg.reply_type || originalMsg?.type;

    if (['link', 'text'].includes(type)) {
        const text = msg.reply_message || originalMsg?.message || '';
        return checkLink(changeText(text), true);
    }
    if (type === 'sticker') {
        return i18n.global.t('Common.sticker', 'Sticker');
    }
    const name = msg.reply_mediaOriginalName || msg.reply_mediaName || originalMsg?.mediaOriginalName || originalMsg?.mediaName;
    if (name) {
        return name;
    }
    switch (type) {
        case 'image': return i18n.global.t('Common.image', 'Image');
        case 'pdf': return i18n.global.t('Common.pdf', 'PDF');
        case 'audio': return i18n.global.t('Common.audio', 'Audio');
        case 'video': return i18n.global.t('Common.video', 'Video');
        case 'excel': return i18n.global.t('Common.excel', 'Excel');
        case 'word': return i18n.global.t('Common.word', 'Word');
        case 'ppt': return i18n.global.t('Common.ppt', 'PPT');
        case 'zip': return i18n.global.t('Common.zip', 'Zip');
        default: return i18n.global.t('Common.file', 'File');
    }
};

const getReplyHighlightTarget = (msg = {}) => {
    if (msg.reply && Object.keys(msg.reply).length) {
        return msg.reply;
    }

    const replyId = msg.reply_id || msg.replyId || msg.replyMessageId;
    if (!replyId) return {};

    return {
        _id: replyId,
        id: replyId,
    };
};


const userId = inject("$userId");
const companyId = inject("$companyId");
// IMAGES
const verticalDots = require("@/assets/images/svg/three_dots_grey.svg");
const replyChatGrey = require("@/assets/images/svg/reply_chat_grey.svg");
const reactionChat = require("@/assets/images/svg/reaction_chat_grey.svg");
// const reactionChatGrey = require("@/assets/images/svg/reaction_chat_grey.svg");
const likeIcon = require("@/assets/images/likeIcon.png");

// REACTION
const reactionPopup = ref(null);
const store = useStore();

const LOCAL_REACTION_MAP = {
    LOVE: require("@/assets/images/reactions/love.png"),
    HAHA: require("@/assets/images/reactions/haha.png"),
    WOW: require("@/assets/images/reactions/wow.png"),
    SAD: require("@/assets/images/reactions/sad.png"),
    ANGRY: require("@/assets/images/reactions/angry.png"),
    LIKE: require("@/assets/images/reactions/like.png"),
};

const reactionList = computed(() => {
    return (store.getters["settings/reactionEmoji"] || []).map((r) => ({
        ...r,
        displaySrc: LOCAL_REACTION_MAP[r.value] || "",
    }));
});

const emit = defineEmits([
    "createTask",
    "copy",
    "share",
    "reply",
    "edit",
    "delete",
    "markUnread",
    "addCheckList",
    "highlight",
    "pin",
    "previewImage",
    "downloadUrl",
    "react",
    "removeReaction",
]);

function openUserProfile(profileUserId) {
    if (!profileUserId) return;
    window.dispatchEvent(new CustomEvent('open-user-profile', {
        detail: { userId: profileUserId }
    }));
}

defineComponent({
    name: "Comment-Component",
    components: {
        DropDown,
        DropDownOption,
        ImageIcon,
    },
});

// PROPS
const props = defineProps({
    mainChat: {
        type: Boolean,
        default: false,
    },
    message: {
        type: Object,
        default: () => {},
    },
    showDay: {
        type: Boolean,
        default: false,
    },
    showOptions: {
        type: Boolean,
        default: true,
    },
    showUser: {
        type: Boolean,
        default: false,
    },
    showMessageTime: {
        type: Boolean,
        default: false,
    },
    showSenderName: {
        type: Boolean,
        default: false,
    },
    showUnread: {
        type: Number,
        default: 0,
    },
    messageAllowed: {
        type: Boolean,
        default: true,
    },
    messageMap: Object,
    canPin: {
        type: Boolean,
        default: true,
    },
    isGroupChat: {
        type: Boolean,
        default: false,
    },
    isChannel: {
        type: Boolean,
        default: false,
    },
});

const showMore = ref(false);
const taskShareCard = computed(() => {
    if (props.message?.type !== "link") return null;
    return parseTaskShareMessage(props.message.message);
});

// function openFileInWindow(url) {
//     window.open(url, "_blank")
// }
const openReaction = (id) => {
    reactionPopup.value = id;
};

const closeReaction = (id) => {
    if (reactionPopup.value === id) {
        reactionPopup.value = null;
    }
};

const selectReaction = (message, emoji) => {
    toggleReaction(message, emoji);
    reactionPopup.value = null;
};

const toggleReaction = (message, emoji) => {
    const reactions = [...(message.reactions || [])];

    const index = reactions.findIndex(r => r.userId === userId.value);

    if (index === -1) {
        reactions.push({
            emoji: emoji.value,
            userId: userId.value,
            createdAt: new Date().toISOString(),
        });
    } else if (reactions[index].emoji === emoji.value) {
        reactions.splice(index, 1);
    } else {
        reactions[index] = {
            ...reactions[index],
            emoji: emoji.value,
        };
    }

    // 🔥 QUAN TRỌNG: gán lại object mới
    message.reactions = reactions;

    emit("react", {
        messageId: message._id,
        emoji: emoji.value,
    });
};

const removeMyReaction = (message) => {
    if (!hasOwnReaction(message)) return;

    emit("removeReaction", {
        messageId: message._id,
    });

    reactionPopup.value = null;
};

const hasOwnReaction = (message) => {
    return (message?.reactions || []).some((reaction) => String(reaction.userId) === String(userId.value));
};

function isPendingMessage(message = {}) {
    return Boolean(message.isSending || message.sendStatus === "sending");
}

function isPendingMediaMessage(message = {}) {
    return Boolean(message.mediaURL || message.mediaName || !["text", "link", "like"].includes(message.type));
}

function getFileCardExtension(message = {}) {
    const extension = (message.mediaOriginalName || message.mediaName || "").split(".").pop() || "";
    const isImageFileCard = message.type === "file" && ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg", "heic", "heif"].includes(extension.toLowerCase());
    return isImageFileCard ? "image-file" : extension;
}

const messageRef = computed(() => props.message);
const currentUserIdRef = computed(() => userId.value);
const { totalReactionCount, topReactionEmojis, ownLatestReaction } = useMessageReactions(messageRef, currentUserIdRef, LOCAL_REACTION_MAP);

// const isMyReaction = (reactions = [], value) => {
//     return reactions.some((r) => r.userId === userId.value && r.emoji === value);
// };

const downloadValue = ref("");
function downloadurl(e) {
    downloadValue.value = e;
}

const DOWNLOAD_ON_CLICK_EXTENSIONS = ["rar", "zip", "7z", "tar", "gz"];

function getMessageExtension(message = {}) {
    return (message.mediaOriginalName || message.mediaName || "").split(".").pop()?.toLowerCase() || "";
}

async function getMessageDownloadUrl(message = {}) {
    let properUrl = downloadValue.value || message.downloadURL || message.mediaURL || "";
    if (!properUrl) return "";
    properUrl = String(properUrl);

    if (!/^https?:\/\//i.test(properUrl)) {
        const fetchedUrl = await getStorageImage({
            companyId: companyId.value,
            data: { url: properUrl },
            isCache: true,
        });
        properUrl = fetchedUrl ? String(fetchedUrl) : "";
    }

    return properUrl;
}

function pauseOthers(type, id) {
    let items = Array.from(document.getElementsByTagName(`${type}`));

    items.forEach((item) => {
        if (!item.id || item.id !== id) {
            item.pause();
        }
    });
}

async function previewImageFun() {
    const extension = getMessageExtension(props.message);
    if (DOWNLOAD_ON_CLICK_EXTENSIONS.includes(extension)) {
        const url = await getMessageDownloadUrl(props.message);
        if (url) {
            await download(url, props.message.mediaOriginalName || props.message.mediaName || "download");
        }
        return;
    }

    let previewData = {
        title: props.message.mediaOriginalName,
        filename: props.message.mediaOriginalName,
        extension,
        type: props.message.type,
        url: downloadValue.value ? downloadValue.value : props.message.mediaURL,
        downloadUrl: downloadValue.value ? downloadValue.value : props.message.mediaURL,
    };
    emit("previewImage", previewData);
}
function formatFileSize(bytes) {
    if (!bytes) return "";
    const k = 1024;
    const sizes = ["B", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return (bytes / Math.pow(k, i)).toFixed(1) + " " + sizes[i];
}

async function processUrl(message) {
    if (!message) return;

    // Chỉ xử lý với media (tuỳ bạn có thêm "file" hay không)
    const isMedia = ["video", "audio", "image"].includes(message.type);
    if (!isMedia) {
        return;
    }

    // Ưu tiên dùng downloadURL, fallback sang mediaURL
    let properUrl = message.downloadURL || message.mediaURL;

    if (!properUrl.includes("http")) {
        try {
            const fetchedUrl = await getStorageImage({
                companyId: companyId.value,
                data: { url: properUrl },
                isCache: true,
            });

            if (fetchedUrl) {
                properUrl = fetchedUrl;
            } else {
                console.error("getStorageImage returned an invalid response:", fetchedUrl);
                return;
            }
        } catch (error) {
            console.error(`Error fetching URL for ${message.mediaOriginalName}:`, error);
            return;
        }
    }

    // Tuỳ bạn đang dùng kiểu gì, nếu Comment emit ra object:
    // emit('downloadUrl', { id: message._id, url: properUrl });
    handleDownloadUrl({
        id: message._id,
        url: properUrl,
    });
}

function handleDownloadUrl(url) {
    emit("downloadUrl", { url, id: props.message._id });
}

onMounted(async () => {
    await processUrl(props.message);
});
</script>

<style scoped>
@import "./style.css";
@media (min-width: 1300px) {
    .message_replay {
        max-width: 460px;
    }
}
@media (min-width: 1440px) {
    .message_replay {
        max-width: 590px;
    }
}
@media (min-width: 1640px) {
    .message_replay {
        max-width: 840px;
        box-shadow: inset 2px 0 0 #016cd7;
        border-radius: 4px;;
    }
}

.reaction-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

/* bong bóng */
.reaction-popup {
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 8px;
    padding: 4px 8px;
    background: #fafafa;
    border-radius: 8px;
    z-index: 100;
    animation: reactionPop 0.15s ease-out;
    white-space: nowrap;
    width: max-content;

    box-shadow:
        0 0 1px 0 rgba(0, 0, 0, 0.05),
        0 0 4px 0 rgba(0, 0, 0, 0.05),
        0 0 44px 0 rgba(0, 0, 0, 0.1);
}

.reaction-popup::after {
    content: "";
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -20px;
    width: 120px;
    height: 20px;
    background: transparent;
}

.reaction-popup::before {
    content: "";
    position: absolute;

    bottom: -6px;
    left: 50%;
    transform: translateX(-50%);

    border-width: 6px 6px 0 6px;
    border-style: solid;
    border-color: #fff transparent transparent transparent;
}
.reaction-bar {
    display: flex;
    padding: var(--3xs, 4px) var(--2xs, 6px);
    justify-content: center;
    align-items: center;
    gap: var(--none, 0);
    border-radius: var(--round, 9999px);
    border: 1px solid var(--Gray-5, #E5E5EA);
    background: var(--Others-grayMedium, #FAFAFA);
    width: auto;
    height: 24px;
    bottom: -12px;
    right: 4px;
    gap: 2px;

}
.reaction-img-small {
    width: 14px;
    height: 14px;
}
.reaction-item {
    display: flex;
    align-items: center;
    justify-content: center;
}
/* emoji */
.reaction-emoji {
    font-size: 22px;
    cursor: pointer;
    transition: transform 0.12s;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 22px;
    max-height: 22px;
}

.reaction-emoji:hover {
    transform: scale(1.35);
}
.edited-message-text {
    align-self: flex-start;
    color: var(--Blue-700, #014D99);
    font-family: var(--Typo-System-Button-S-Font, Inter);
    font-size: var(--Typo-System-Button-S-fontSize, 12px);
    font-style: normal;
    font-weight: 500;
    line-height: var(--Typo-System-Button-S-lineHeight, 16px); /* 133.333% */
    letter-spacing: var(--Typo-System-Button-S-letterSpacing, 0.1px);
}
.right-message .edited-message-text {
    align-self: flex-end;
}
.reaction-img {
    max-width: unset !important;
}
/* animation */
.reply-file-icon {
    width: 25px;
    height: 25px;
    object-fit: contain;
    flex-shrink: 0;
}
@keyframes reactionPop {
    from {
        opacity: 0;
        transform: translateX(-50%) scale(0.85);
    }
    to {
        opacity: 1;
        transform: translateX(-50%) scale(1);
    }
}
.reply-icon {
    content: url('@/assets/images/svg/reply_chat_grey.svg');
}

.actions__dropdown:hover .reply-icon {
    content: url('@/assets/images/svg/reply_chat_black.svg');
}
.reaction-btn {
    content: url('@/assets/images/svg/reaction_chat_grey.svg');
}

.actions__dropdown:hover .reaction-btn {
    content: url('@/assets/images/svg/reaction_chat_black.svg');
}
.verticalDots {
    content: url('@/assets/images/svg/three_dots_grey.svg');
}

.actions__dropdown:hover .verticalDots {
    content: url('@/assets/images/svg/three_black_dots.svg');
}

.reaction-wrap {
    gap: 2px;
}
.reaction-pill {
    background: var(--Others-colorReverse, #f8fafc);
    border: 1px solid var(--Neutral-Stroke-Stroke, #e5e7eb);
    padding: 2px 6px !important;
    height: 24px;
}
.own-reaction-bubble {
    background: var(--Others-colorReverse, #f8fafc);
    border: 1px solid var(--Neutral-Stroke-Stroke, #e5e7eb);
    width: 24px;
    height: 24px;
}
.reaction-icons-row {
    align-items: center;
}
.overlap-icon {
    margin-left: -5px;
}
.reaction-count-text {
    color: var(--Others-textColor, #111827);
    font-weight: 500;
}
.message-send-status {
    font-size: 11px;
    font-weight: 400;
    line-height: 14px;
    margin-top: 4px;
    text-align: right;
}
.message-send-status--loading {
    align-items: center;
    color: #6b7280;
    display: flex;
    gap: 6px;
    justify-content: flex-end;
}
.message-send-spinner {
    animation: message-send-spin 0.8s linear infinite;
    border: 2px solid #cfd6e4;
    border-top-color: #016cd7;
    border-radius: 50%;
    display: inline-block;
    height: 12px;
    width: 12px;
}
.task-share-card {
    align-items: flex-start;
    background: #fff;
    border: 1px solid #d7e6f7;
    border-radius: 10px;
    box-shadow: 0 4px 14px rgba(1, 108, 215, 0.08);
    color: #12233f;
    display: flex;
    gap: 10px;
    max-width: 420px;
    min-width: 300px;
    padding: 12px;
    text-decoration: none;
    transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}
.task-share-card:hover {
    border-color: #80b8ef;
    box-shadow: 0 6px 18px rgba(1, 108, 215, 0.14);
    color: #12233f;
    text-decoration: none;
    transform: translateY(-1px);
}
.task-share-card__icon {
    align-items: center;
    background: #e8f3ff;
    border-radius: 8px;
    color: #016cd7;
    display: inline-flex;
    flex: 0 0 34px;
    font-size: 18px;
    font-weight: 700;
    height: 34px;
    justify-content: center;
}
.task-share-card__content {
    display: flex;
    min-width: 0;
    flex: 1;
    flex-direction: column;
}
.task-share-card__eyebrow {
    color: #6b7b91;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.08em;
    line-height: 14px;
    text-transform: uppercase;
}
.task-share-card__key {
    color: #016cd7;
    font-size: 13px;
    line-height: 18px;
    margin-top: 2px;
}
.task-share-card__name {
    color: #12233f;
    display: -webkit-box;
    font-size: 14px;
    font-weight: 600;
    line-height: 19px;
    margin-top: 2px;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.task-share-card__action {
    align-self: flex-end;
    color: #016cd7;
    font-size: 12px;
    font-weight: 600;
    margin-top: 10px;
}
@media (max-width: 480px) {
    .task-share-card {
        min-width: 240px;
        width: min(320px, calc(100vw - 100px));
    }
}
@keyframes message-send-spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
